
import React from 'react';
import { CheckCircle2, Clock, Settings } from 'lucide-react';

interface ExecutiveSummaryProps {
  summary: string;
  executedAt: string;
  duration: string;
  entitiesProcessed: number;
}

export const ExecutiveSummary = ({ 
  summary, 
  executedAt, 
  duration, 
  entitiesProcessed 
}: ExecutiveSummaryProps) => {
  // Format execution time
  const formatTime = (isoString: string) => {
    return new Date(isoString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };
  
  return (
    <div className="p-4 border-t border-b">
      <h3 className="text-sm font-semibold mb-2 flex items-center">
        <CheckCircle2 className="h-4 w-4 mr-1 text-primary" /> 
        Executive Summary
      </h3>
      <p className="text-sm text-muted-foreground">
        {summary}
      </p>
      <div className="mt-3 text-sm">
        <div className="flex items-center mb-1">
          <Clock className="h-4 w-4 mr-1 text-muted-foreground" /> 
          <span className="text-xs text-muted-foreground">
            Executed: {formatTime(executedAt)} • Duration: {duration}
          </span>
        </div>
        <div className="flex items-center">
          <Settings className="h-4 w-4 mr-1 text-muted-foreground" /> 
          <span className="text-xs text-muted-foreground">
            Entities processed: {entitiesProcessed}
          </span>
        </div>
      </div>
    </div>
  );
};
